<template>
  <section class="p-2">
    <v-card>
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">Create {{ entityLabel }}</div>
        <div>
          <bread-crumb :bread-crumbs="breadCrumbs" />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
    </v-card>
    <v-card-text>
      <v-tabs color="primary" v-model="tabSeleted" grow slider-color="primary">
        <v-tab
          v-for="item in filteredTabs"
          :key="item.key"
          :href="'#' + item.key"
          :disabled="item.disabled"
          color="white"
          class="text-capitalize text-decoration-none"
        >
          {{ item.label }}
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tabSeleted">
        <!-- <v-tab-item id="partner">
                <Companydetails @companyDetails="companyDetails" />
              </v-tab-item> -->
        <v-tab-item id="partner">
          <Companydetails
            :entity-label="entityLabel"
            :is-corridor="isCorridor"
            @companyDetails="companyDetails"
          />
        </v-tab-item>
        <v-tab-item id="others">
          <Otherdetails :getCompanyDetails="getCompanyDetails" />
        </v-tab-item>
        <v-tab-item id="paymennt_mode">
          <PaymentMode :getCompanyDetails="getCompanyDetails" />
        </v-tab-item>
        <v-tab-item id="remarks">
          <!-- <Remarks :getCompanyDetails="getCompanyDetails" /> -->
        </v-tab-item>
        <v-tab-item id="allowed">
          <AllowedCurrency :getCompanyDetails="getCompanyDetails" />
        </v-tab-item>
        <v-tab-item id="agent">
          <AgentFunction :getCompanyDetails="getCompanyDetails" />
        </v-tab-item>
        <v-tab-item id="deposite_channel">
          <DepositeChannel :getCompanyDetails="getCompanyDetails" />
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>
  </section>
</template>
<script>
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import Companydetails from "./agentTabs/Companydetails.vue";
import AgentFunction from "./agentTabs/AgentFunction.vue";
import AllowedCurrency from "./agentTabs/AllowedCurrency.vue";
import PaymentMode from "./agentTabs/paymentMode.vue";
import Otherdetails from "./agentTabs/Otherdetails.vue";
import DepositeChannel from "./agentTabs/DepositeChannel.vue";
export default {
  name: "Create Agent",
  components: {
    BreadCrumb,
    Companydetails,
    AgentFunction,
    AllowedCurrency,
    Otherdetails,
    PaymentMode,
    DepositeChannel,
  },
  data() {
    return {
      tabSeleted: 0,
      getCompanyDetails: null,
      showAdditionalTabs: false,
      items: [
        { label: "Info", key: "partner", disabled: false },
        {
          label: "Others",
          key: "others",
          // disabled: this.$route.query.partner_id ? false : true,
        },
        {
          label: "Payment Mode",
          key: "paymennt_mode",
          // disabled: this.$route.query.partner_id ? false : true,
        },
        {
          label: "Allowed Currency",
          key: "allowed",
          // disabled: this.$route.query.partner_id ? false : true,
        },
        {
          label: "Agent Function",
          key: "agent",
          // disabled: this.$route.query.partner_id ? false : true,
        },
        {
          label: "Deposit Channel",
          key: "deposite_channel",
          // disabled: this.$route.query.partner_id ? false : true,
        },
      ],
    };
  },
  created() {
    const partnerId = this.$route.query.partner_id;
    console.log("partnerId", partnerId);
    this.showAdditionalTabs = !!partnerId;
  },
  computed: {
    isCorridor() {
      return String(this.$route.query.partner_type_code) === "3" ? false : true;
    },
    entityLabel() {
      return !this.isCorridor ? "Channel" : "Corridor";
    },
    breadCrumbs() {
      return ["Agent Summary", `Create ${this.entityLabel}`];
    },
    filteredTabs() {
      const tabs = this.items.map((item) =>
        item.key === "partner"
          ? { ...item, label: `${this.entityLabel} Info` }
          : item,
      );

      return this.showAdditionalTabs
        ? tabs
        : tabs.filter((item) => item.key === "partner");
    },
  },
  methods: {
    companyDetails(val) {
      if (val) {
        this.getCompanyDetails = val;
      }
    },
  },
};
</script>
